import { useDrawerStore } from '../..'
import type { Drawer } from './types'

const getDrawerStore = () => useDrawerStore.getState()

export const drawerActions = {
    addDrawer: (drawer?: Partial<Omit<Drawer, 'index'>>) => getDrawerStore().addDrawer(drawer),
    removeDrawer: (index: number) => getDrawerStore().removeDrawer(index),
    toggleDrawer: (index: number) => getDrawerStore().toggleDrawer(index),
    clearAllDrawers: () => getDrawerStore().clearAllDrawers(),
    updateDrawer: (index: number, updates: Partial<Omit<Drawer, 'index'>>) =>
        getDrawerStore().updateDrawer(index, updates),
}
